__turbopack_context__.v({
  "className": "_84jm3a_className",
  "variable": "_84jm3a_variable",
});
